import { PAYEX_URL } from 'constants/config';
import type { User } from 'models/user';
import { fetchWithAuthentication } from 'utils/fetchJson/fetchJson';

import type { UpdateUserPayload } from './types';

export const users = {
  updateUser: (payload: UpdateUserPayload) => {
    const path = `${PAYEX_URL}/users`;
    const body = JSON.stringify(payload);

    const options = {
      method: 'PATCH',
      body,
    };

    return fetchWithAuthentication<
      Pick<User, 'firstName' | 'lastName' | 'email'>
    >(path, options);
  },
};
